import { EmptyState } from '@loadsmart/loadsmart-ui'
import { Layout, Text } from '@loadsmart/miranda-react'

import { RequestStatus } from 'core/domain/Request'
import IllustrationBrokenLink from 'core/ui/assets/illustration-broken-link.svg'
import IllustrationGenericError from 'core/ui/assets/illustration-generic-error.svg'
import { LoadingState } from 'core/ui/async-content/LoadingState'

export type ExpiredInviteStateProps = {
  emailRecipient?: string
  refreshInviteTokenStatus: RequestStatus
}

export function ExpiredInviteState({
  emailRecipient,
  refreshInviteTokenStatus,
}: ExpiredInviteStateProps) {
  if (!emailRecipient && refreshInviteTokenStatus === RequestStatus.Pending) {
    return <LoadingState />
  }

  if (refreshInviteTokenStatus === RequestStatus.Error) {
    return (
      <Layout.Stack gap="spacing-4" align="center" paddingT="spacing-12">
        <EmptyState
          variant="page"
          illustration={IllustrationGenericError}
          title="Something went wrong"
          description="Your access link has expired and we could not send you a new one. Please reload the page to try again."
        />
      </Layout.Stack>
    )
  }

  return (
    <Layout.Stack gap="spacing-4" align="center" paddingT="spacing-12">
      <img alt="Email sent" src={IllustrationBrokenLink} width={320} />
      <Layout.Stack gap="spacing-2" align="center">
        <Text variant="heading-sm-bold">We just sent you an e-mail</Text>
        <Text variant="body-md" style={{ textAlign: 'center' }}>
          For security reasons we sent another access link
          <br /> to {emailRecipient ?? 'your e-mail address'}. Verify your inbox.
        </Text>
      </Layout.Stack>
    </Layout.Stack>
  )
}
